import { render, staticRenderFns } from "./s-detail.vue?vue&type=template&id=5e44dd40&"
import script from "./s-detail.vue?vue&type=script&lang=js&"
export * from "./s-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports